/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';

import {
  Chip,
  Grid,
  Typography,
  Tooltip,
  IconButton,
  Box,
  Stack,
  CircularProgress,
} from '@mui/material';
import { Link } from 'react-router-dom';

import './styles.css';
import { COLOR } from '../../helpers/colors';

class ProductCard extends Component {
  render() {
    const {
      body,
      title,
      image = null,
      attribute = null,
      location = null,
      icons = null,
      titleRight = null,
      rightBody = null,
      borderColor = null,
      navigationUrl,
      isSelected,
      product = null,
    } = this.props;

    return (
      <Box
        sx={{
          mt: 1,
          p: { xs: 0, sm: 0, md: 1 },
          border: isSelected ? '2px solid #05f' : 'none',
          borderBottom: !isSelected ? `1px solid ${COLOR.borderColor}` : 'auto',
        }}
      >
        <Box
          sx={
            borderColor !== null
              ? {
                  pl: 1,
                  mt: 1,
                  mb: 1,
                  borderLeft: `3px solid ${borderColor}`,
                }
              : {}
          }
        >
          {attribute !== null ? (
            <Stack direction="row" justifyContent={{ xs: 'flex-start', md: 'flex-end' }}>
              <Chip
                label={attribute.value}
                sx={{
                  background: attribute.color,
                  color: COLOR.whiteTextColor,
                  fontSize: { xs: 8, md: 12 },
                  height: 20,
                  marginY: 0.5,
                  width: 100,
                  fontWeight: 700,
                }}
              />
            </Stack>
          ) : null}
          <Grid
            container
            style={{ marginTop: 5 }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            textAlign="center"
          >
            <Grid sx={{ mt: 0.5 }}>
              <Typography
                sx={{
                  cursor: 'pointer',
                  fontSize: 14,
                  fontWeight: '700',
                  ':hover': {
                    textDecoration: 'underline',
                  },
                }}
                // className="material-title"
              >
                {title}
              </Typography>
            </Grid>
            <Grid>{titleRight}</Grid>
          </Grid>

          <Grid container item direction="row" justifyContent="flex-start">
            {image !== null ? (
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                xs={12}
                sm={12}
                md={2}
                alignSelf="center"
                textAlign="center"
                sx={{ mt: { xs: 2, md: 0 }, mb: { xs: 2, md: 0 } }}
              >
                <Box />
                <Link to={navigationUrl}>
                  <img
                    src={image}
                    alt=""
                    loading="lazy"
                    className="img-product"
                    onError={e => {
                      // e.target.src = 'https://i.ibb.co/SXnBvh2/no-image-available.png';
                      e.target.src = '/no-image-available.png';
                    }}
                  />
                </Link>
              </Grid>
            ) : null}
            <Grid
              item
              xs={12}
              sm={12}
              md={8}
              sx={{
                pl: { xs: 0, sm: 0, md: image !== null ? 2 : 0 },
                pr: { xs: 0, sm: 0, md: image !== null ? 2 : 0 },
              }}
            >
              {body}
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={2}
              // sx={{
              //   pl: { xs: 0, sm: 0, md: image !== null ? 2 : 0 },
              //   pr: { xs: 0, sm: 0, md: image !== null ? 2 : 0 },
              // }}
              container
              flexDirection="row"
              justifyContent="flex-end"
            >
              {rightBody}
            </Grid>
          </Grid>
          <Grid
            item
            container
            direction="row"
            justifyContent={location !== null ? 'space-between' : 'flex-end'}
            xs={12}
            alignItems="center"
            spacing={2}
          >
            {location !== null ? <Typography>{location}</Typography> : null}
            {icons !== null
              ? icons.map((i, index) => (
                  <Grid item key={index.toString()}>
                    {i.showLoader && product.Material === i.selectedMaterial ? (
                      <CircularProgress size={20} />
                    ) : (
                      <Tooltip title={i.title}>
                        <span>
                          <IconButton onClick={i.onClick} disabled={i.disable}>
                            <i.icon
                              sx={{ fontSize: 16, color: i.disable ? COLOR.borderColor : i.color }}
                            />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                  </Grid>
                ))
              : null}
          </Grid>
        </Box>
      </Box>
    );
  }
}

export default ProductCard;
